import React from 'react';
import SvgIconDPC from "../dpc-svg-icon-iononrischio";

export default class LinksDPC extends React.Component {
    render() {
        if (Array.isArray(this.props.links) && this.props.links)
            return (
                <ul className="it-list">
                    {this.props.links.map(link =>
                        <li>
                            <a href={link.slug} title={link.titleLinkEsterno ? link.titleLinkEsterno : link.title} target={link.titleLinkEsterno ? '_blank':'_self'} rel="noopener noreferrer">
                                
                                    {link.svg ? 
                                    <SvgIconDPC name={link.svg} classiAggiuntive={"mr-3"}/>
                                    :null}
                                    <span className="text" style={{overflowWrap:"anywhere"}} dangerouslySetInnerHTML={{__html: link.title}}/>
                                
                            </a>
                        </li>
                    )}
                </ul>
            );
        if (Array.isArray(this.props.linksNormative) && this.props.linksNormative)
            return (<ul className="it-list">
                {this.props.linksNormative.map(link =>
                    <li>
                        <a href={link.field_link.uri} title={link.field_link.title}>
                            <div><span className="text" style={{overflowWrap:"anywhere"}}>{link.field_link.title}</span>
                            </div>
                        </a>
                    </li>
                )}
            </ul>);
        return ("");
    }
}


